enum StoreEnum {
    AUTH = 'authStore',
    THREE_D = 'threeDStore',
    SCAN = 'scanStore',
    SETTINGS = 'settingsStore',
    ADMIN = 'adminStore',
    ORDER = 'orderStore',
    PATIENT = 'patientStore',
    SOLE = 'soleStore',
    VIEWER = 'viewerStore',
    SOLE_PRESET = 'solePresetStore',
}

export default StoreEnum;
